import { Platform } from "react-native"

/**
 * Triggers a browser file download on web only.
 * Returns false on native (no file system / share sheet is wired up here).
 */
export function downloadFile(content: string, filename: string, mime = "text/csv;charset=utf-8;") {
  if (Platform.OS !== "web") {
    return false
  }

  const blob = new Blob([content], { type: mime })
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement("a")
  anchor.href = url
  anchor.download = filename
  document.body.appendChild(anchor)
  anchor.click()
  document.body.removeChild(anchor)
  URL.revokeObjectURL(url)
  return true
}
